<template>
  <div class="audio" @click="autoPlay">
    <img class="icon" :src="require(`../assets/${isPlay ? `play.gif` : `ic_live.png`}`)" alt="">
  </div>
</template>

<script>
export default {
  props: {
    recordFile: {
      type: String
    }
  },
  name: 'audioComp',
  data() {
    return {
      isPlay: false,
      myAuto: new Audio(this.recordFile)
    }
  },
  methods: {
    autoPlay() {
      this.isPlay = !this.isPlay
      if (this.isPlay) {
        this.myAuto.play()
        this.palyEnd()
      } else {
        this.myAuto.pause()
        this.palyEnd()
      }
    },
    palyEnd() {
      this.myAuto.addEventListener('ended', () => {
        this.isPlay = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.audio {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0.2rem;
  width: 0.54rem;
  height: 0.26rem;
  border-radius: 0.25rem;
  background: linear-gradient(270deg, #00caff 0%, #007fff 100%);
  &:lang(ar) {
    right: auto;
    left: 0.2rem;
  }
  .icon {
    width: 0.2rem;
    height: 0.2rem;
  }
}
</style>

